import React from 'react'
import { render } from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'

import Routes from './Routes'
import Layout from './Components/Layout'
import './index.scss'

render(
  <React.StrictMode>
    <Router>
      <Layout>
        <Routes />
      </Layout>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
)
